import useIsMobile from '@/hooks/useIsMobile';
import useThankYou from './useThankYou';
import ThankYouDesktop from './desktop';
import ThankYouMobile from './mobile';

function ThankYou() {
  const isMobile = useIsMobile(992);
  const viewModel = useThankYou();

  return isMobile ? <ThankYouMobile viewModel={viewModel} /> : <ThankYouDesktop viewModel={viewModel} />;
}

export default ThankYou;
